const ERC721ABI = [{
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "approve",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "mint",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "safeTransferFrom",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }, {
      "internalType": "bytes",
      "name": "_data",
      "type": "bytes"
  }],
  "name": "safeTransferFrom",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "bool",
      "name": "approved",
      "type": "bool"
  }],
  "name": "setApprovalForAll",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "transferFrom",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "constructor"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "Transfer",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "address",
      "name": "approved",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "Approval",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "address",
      "name": "operator",
      "type": "address"
  }, {
      "indexed": false,
      "internalType": "bool",
      "name": "approved",
      "type": "bool"
  }],
  "name": "ApprovalForAll",
  "type": "event"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }],
  "name": "balanceOf",
  "outputs": [{
      "internalType": "uint256",
      "name": "",
      "type": "uint256"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "getApproved",
  "outputs": [{
      "internalType": "address",
      "name": "",
      "type": "address"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "operator",
      "type": "address"
  }],
  "name": "isApprovedForAll",
  "outputs": [{
      "internalType": "bool",
      "name": "",
      "type": "bool"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "ownerOf",
  "outputs": [{
      "internalType": "address",
      "name": "",
      "type": "address"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "bytes4",
      "name": "interfaceId",
      "type": "bytes4"
  }],
  "name": "supportsInterface",
  "outputs": [{
      "internalType": "bool",
      "name": "",
      "type": "bool"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}];

// Mainnet DAI, Optimism and Arbitrium Rollup Contracts with local addresses
module.exports = {
  31337: {
    contracts: {
      Pinyottas: {
        address: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
        abi: ERC721ABI,
      },
      PinyottaChecks: {
        address: "0x2279B7A0a67DB372996a5FaB50D91eAA73d2eBe6",
        abi: ERC721ABI,
      },
      Phrumps: {
        address: "0xB7f8BC63BbcaD18155201308C8f3540b07f84F5e",
        abi: ERC721ABI,
      },
      q00tants: {
        address: "0x9A676e781A523b5d0C0e43731313A708CB607508",
        abi: ERC721ABI,
      },
      q00nicorns: {
        address: "0x9A9f2CCfdE556A7E9Ff0848998Aa4a0CFD8863AE",
        abi: ERC721ABI,
      },
      tdg: {
        address: "0x23294ef5bd5ec2fca40904f7cd4a48e73781f207",
        abi: ERC721ABI,
      }
    },
  },
  5: {
    contracts: {
      Pinyottas: {
        address: "0x6F2dCC41b1140fDd2124969580eC7272B9137A9e",
        abi: ERC721ABI,
      },
      PinyottaChecks: {
        address: "0xA44BF22233715282eDB11c15a817237c603A5e55",
        abi: ERC721ABI,
      },
      Phrumps: {
        address: "0xEeE5DA6c08FfA9bb8937E6b7dfFfF667AbEB7f12",
        abi: ERC721ABI,
      },
      q00tants: {
        address: "0x7318943Dcb0e0Adf04ed670C682586fa3359466f",
        abi: ERC721ABI,
      },
      q00nicorns: {
        address: "0x99726039E2Be441139da693B0d070d422C64ED74",
        abi: ERC721ABI,
      },
      tdg: {
        address: "0x23294ef5bd5ec2fca40904f7cd4a48e73781f207",
        abi: ERC721ABI,
      }
    },
  },
  1: {
    contracts: {
      Pinyottas: {
        address: "0x2861E4D8e26b10029E5cD1D236239f810c664B99",
        abi: ERC721ABI,
      },
      PinyottaChecks: {
        address: "0xb5a7e28cd2bf8897d6d1bd4f05ad8cc7ef457bb9",
        abi: ERC721ABI,
      },
      Phrumps: {
        address: "0x1453a8a253ac08b15dbb785bb3bad99bae5fe7ed",
        abi: ERC721ABI,
      },
      q00tants: {
        address: "0x862c9b564fbdd34983ed3655aa9f68e0ed86c620",
        abi: ERC721ABI,
      },
      q00nicorns: {
        address: "0xb1b853a1aac513f2ab91133ca8ae5d78c24cb828",
        abi: ERC721ABI,
      },
      tdg: {
        address: "0x23294ef5bd5ec2fca40904f7cd4a48e73781f207",
        abi: ERC721ABI,
      }
    },
  },
};
